export default "__VITE_ASSET__ZuNGRTwz__"